<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" id="benefitHeader">{{pageTitle}}</div>
                <button type="submit" id="BackBtn" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack()">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="forms-container">
                    <div class="row no-margin">
                        <!-- Title -->
                        <div class="col-12 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label" for="dayForceId">Folder Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="titleError = ''" maxlength="190" v-model="title" type="text" class="form-control" id="dayForceId" placeholder="Enter Folder Name">
                                <div class="requiredstar">*</div>
                                <font class="text-danger">{{titleError}}</font>
                            </div>
                        </div>
                        
                    </div>
                    
                <div class="clearfix"></div>

                <!--Buttons-->
                <div class="row clearfix"></div>
                <!-- <div class="button-demo"> -->
                    <input id="addBenifitBtn" type="submit" value="Save" class="ml-2 btn btn-primary pull-right" v-on:click.prevent="addUpdateManagerToolBox(flag = 'Save')">
                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="ml-2 btn btn-primary pull-right" v-on:click.prevent="addUpdateManagerToolBox(flag='Save and Continue')">
                    <input id="CancelBenifit" type="submit" value="Cancel" class="ml-2 back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">
                <!-- </div> -->
                </div>
            </div>
            <!--page content-->
        </div>
        <!-- <app-backend-footer></app-backend-footer> -->
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
var self;
// import Vue from 'vue';
import Footer from '@/components/partials/Footer';
// import {commonMixins} from '../mixins/commonMixins';
import { HTTP } from '../../../http-common';
/* https://github.com/xiaokaike/vue-color */
// import { Chrome } from 'vue-color';

export default {
  name: 'AddUpdateFolder',
  // mixins: [commonMixins],
  components: {
    'app-footer': Footer,
    // 'chrome-picker': Chrome,
  },
  data() {
    return {
      titleError: '',
      editId: 0,
      saveButtonTitle: 'Save',
      saveContinueButtonTitle: 'Save And Continue',
      pageTitle: 'Add Folder',
      title: '',
      selectColorBtnTitle: 'Click To Select Color',
      hideColorPicker: true,
      buttonDisable: false,
      colors: {
        hex: '#444444',
        hex8: '#444444',
      },
    }
  },
  created: function () {

  },
  beforeMount: function () {
        self = this;
    },
  mounted: function () {
    var self = this
    var path = window.location.pathname;
    var segments = path.split('/');
    if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
        self.editId = self.$route.params.id;
        self.getFolderById();
        $("#addAndContinueBenifitBtn").hide();
        $("#addBenifitBtn").val("Update");
        self.pageTitle = "Edit Folder";
    }
    //$('.common-disable :input').attr('disabled', true);
  },
  methods: {
    buttonBack: function () {
      var self = this;
      self.$router.push('/backend/listfolder');
    },
    formatString: function (data) {
      var value = data.replace(/_/g, ' ');
      var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });
      return upp;
    },
    addUpdateManagerToolBox: function (flag) {
        var self = this;
        if (self.checkForm()) {
          var config = {
              headers: {Authorization: 'Bearer ' + localStorage.getItem('api_token')}
          };
          var data = {
              id: self.editId,
              name: self.title
          };

          if(flag === 'Save'){
            $("#addBenifitBtn").val("Saving ...");
            $("#addBenifitBtn").prop("disabled", true);
            $("#addAndContinueBenifitBtn").prop("disabled", true);
            $("#CancelBenifit").prop("disabled", true);
            $("#BackBtn").prop("disabled", true);
          } else{
            $("#addAndContinueBenifitBtn").val("Saving ...");
            $("#addAndContinueBenifitBtn").prop("disabled", true);
            $("#addBenifitBtn").prop("disabled", true);
            $("#CancelBenifit").prop("disabled", true);
            $("#BackBtn").prop("disabled", true);
          }

          HTTP.post('/folder/add/update', data, config)
          .then(function (response) {
              if (response.data.code == '200') {
                self.title = '';
                self.$swal('Success', response.data.message, 'success');
                if(flag === 'Save'){
                  self.$router.push('/backend/listfolder');
                }  
              }
              $("#addAndContinueBenifitBtn").val("Save and Continue");
              $("#addAndContinueBenifitBtn").prop("disabled", false);
              $("#addBenifitBtn").prop("disabled", false);
              $("#CancelBenifit").prop("disabled", false);
              $("#BackBtn").prop("disabled", false);
              // console.log(response);
          })
      } 
    },
    getFolderById: function() {
        var config = {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("api_token")
            },
            params : {
                id : this.editId
            }
        };
        HTTP.get('/folder/get', config)
            .then(function (response) {
                console.log(response.data.content.name);
                self.title = response.data.content.name;
            })
            .catch(function (err) {
                if (err.response.status == 0) {
                    self.error = "Remote server can not be reachable";
                } else {
                    //redirect to login page if user not authenticated
                    if (err.response.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("api_token");
                        localStorage.removeItem("profile_image");
                        self.$router.push("/login");
                        //EventBus.$emit("logged-in", true, "", "");
                    }
                    self.error = err.response.data.message;
                }
            });
    },
    checkForm: function () {
      var checked = true;
      if (!self.title) {
          self.titleError = "Folder name Required";
          if (checked) {
              checked = false;
          }
      }
      return checked;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/backend/ManagerToolBox/AddUpdateFolder.vue